// @givmo/app-charity — the appeal's Social tab's composer (EMC-WEB5): Social's own card
// (`SocialComposerEmbed`, SMM-WEB5) as Jonathan's frame 40 draws it inside the tab. The tab hands over
// what `SocialComposerSlotProps` names, the organization's time zone among it, so the card's time reads
// on the clock the tab's list does; Social draws its card, its title and its acts, and decides every
// rule about the post. It renders beneath the console's query client, router and api-client, as Social's
// own pages do.

import type { SocialComposerSlotProps } from '@givmo/fundraisers-module';
import { SocialComposerEmbed } from '@givmo/social';

export function CharitySocialComposer({
  orgRef,
  orgName,
  timeZone,
  permissions,
  context,
  prefill,
  postId,
  onDone,
  onCancel,
  onDeleted,
}: SocialComposerSlotProps) {
  return (
    <SocialComposerEmbed
      orgRef={orgRef}
      orgName={orgName}
      timeZone={timeZone}
      permissions={permissions}
      context={context}
      prefill={prefill}
      postId={postId ?? null}
      onDone={onDone}
      onCancel={onCancel}
      onDeleted={onDeleted}
    />
  );
}
